import { render, staticRenderFns } from "./sdproduct12.vue?vue&type=template&id=69dabe92&scoped=true"
import script from "./sdproduct12.vue?vue&type=script&lang=js"
export * from "./sdproduct12.vue?vue&type=script&lang=js"
import style0 from "./sdproduct12.vue?vue&type=style&index=0&id=69dabe92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dabe92",
  null
  
)

export default component.exports